<template>
  <div class="OptDom">
    <div class="optDom-Input" v-if="isInternalValue">
      <div class="optDom-Input-Email" v-if="optType == 'mobile'">
        <selection :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_CountryRegionCode_PlaceOther')" label="Name"
          v-model="temp_value.contactPhoneCountryCode" :options="cellCountryOptions" :disabled="isCheckEndOpt"
          :ControlId="'contactPhoneCountryCode'" :multiple="false" :appendToBody="true" :zIndex="9999" @fromChird_TreeSelected="PhoneSelected($event)">
        </selection>
        <div class="mobile-input-wrapper" style="position: relative;">
          <textbox :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_CountryPhone_PlaceOther')" type="number" v-model="temp_value.mobileInput" ControlId="optDom_Mobile"
            :class="{ 'is-invalid': temp_value.mobileInput, 'is-verified-mobile': isCheckEndOpt && optType == 'mobile' }" :disabled="isCheckEndOpt">
          </textbox>
          <i v-if="isCheckEndOpt && optType == 'mobile'" class="UserSetting_IsVersion_Icon verified-check-icon-mobile"></i>
        </div>
      </div>
      <div class="optDom-Input-Mobile" v-else>
        <div class="email-input-wrapper" style="position: relative;">
          <textbox :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Email_PlaceOther')" type="email" v-model="temp_value.emailInput" :ControlId="'optDom_Email'"
            :class="{ 'is-verified-email': isCheckEndOpt && optType == 'email' }" :disabled="isCheckEndOpt">
          </textbox>
          <i v-if="isCheckEndOpt && optType == 'email'" class="UserSetting_IsVersion_Icon verified-check-icon-email"></i>
        </div>
      </div>
      <div v-if="!isLoginUse && !isCheckEndOpt">
        <b-button variant="outline-primary" class="UserSetting-VerifyBtn" :disabled="countdown > 0 || !isFormValid"
          v-bind:t_label="'EMP_UserSetting_Verification_SendOpt'" @click="sendOTP">{{
            GetBUttonText }}</b-button>
      </div>
    </div>
    <div class="optDom-Content" v-if="!isInternalValue">
      <span v-if="optType == 'mobile'">
        {{ temp_value.mobileInput }}
      </span>
      <span v-else>
        {{ temp_value.emailInput }}
      </span>
    </div>

    <div v-if="isLoginUse || (isStartOpt  && !isCheckEndOpt)">
      <div class="otp-inputs">
        <input v-for="(digit, index) in otpDigits" :key="index" v-model="otpDigits[index]" type="text" class="otp-input"
          :class="{ 'otp-input-error': otpError }" maxlength="1" @input="handleOtpInput(index, $event)"
          @keydown="handleOtpKeydown(index, $event)" @paste="handleOtpPaste($event)" @focus="clearOtpError" />
      </div>
      <!-- 验证码错误提示 -->
      <div v-if="otpError" class="otp-error-message">
        {{ $t('lbl_emp2_InvalidVerificationCode') }}
      </div>
    </div>

    <div class="otp-inputs-resend" v-if="isLoginUse">
      <button class="btn-resend UserSetting-VerifyBtn" v-bind:t_label="'EMP_UserSetting_LoginVerification_SendOpt'" :disabled="countdown > 0"
        @click="sendOTP">
        {{ GetBUttonText }}
      </button>
    </div>
    <GeetestCaptcha @captchaVerifyCallbackGeetest="finishSlideGeetest" ref="captchaInstance"
      :currentUrlName="GetIsUatName" />
  </div>
</template>
<script>
import { CompanyInfoService, userService } from "../../_services";
import GeetestCaptcha from '../../components/GeetestCaptcha.vue';
import { getContactUsConfig, DEFAULT_SHOW_ID } from '../new-login/Common/new-login-config.js';
import { validateEmail, validateMobileWithCountry } from '../new-login/Common/utils.js';
export default {
  name: 'Verification',
  components: {
    GeetestCaptcha
  },
  props: {
    value: //验证的表单内容  国家/(邮箱|手机)
    {
      type: Object,
      default:
      {
        emailInput: '12345@qq.com',
        mobileInput: '15521791289',
        contactPhoneCountryCode: '',
        contactPhoneCountry: '',
        emailIsVerify: false,
        phoneIsVerify: false
      }
    },
    isInternalValue: {//是否内部填写value
      type: Boolean,
      default: false
    },
    optType: { //验证类型 email/mobile
      type: String,
      default: 'email'
    },
    isLoginUse: {
      type: Boolean,
      default: false
    },
    captchaVerifyParam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    
  },
  data() {
    return {
      isStartOpt:false,
      isCheckEndOpt: false,
      countdown: 0,
      otpError: false,
      temp_value: this.value,
      otpDigits: ['', '', '', ''],
      cellCountryOptions: [],
      checkDataGuid: ''
    };
  },
  mounted() {
    this.InitCaptchaVerifyParam();
    this.getCellCountryOptions();
    this.InitCheckEndOpt();
  },
  computed: {
    GetBUttonText() {
      return this.countdown > 0 ? this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_SendOpt_Timer',{timer: this.countdown}) : this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_SendOpt')
    },
    IsEmail() {
      // 统一使用 new-login 公共邮箱验证规则
      return validateEmail(this.temp_value.emailInput);
    },
    GetIsUatName() {
      var isUatName = process.env.VUE_APP_EMP_ENV_NAME == "UAT" ? "eMarketplaceUat_Back" : "eMarketplace_Back";
      isUatName = process.env.VUE_APP_EMP_ENV_NAME == "AI" ? "eMarketplaceAi_Back" : isUatName;

      return isUatName;
    },
    isFormValid() {
      if (this.optType === 'mobile') {
        // 使用国家码 + 手机号的统一校验
        return validateMobileWithCountry(
          this.temp_value.contactPhoneCountryCode,
          this.temp_value.mobileInput
        );
      } else {
        const email = this.temp_value.emailInput;
        const hasEmail = email !== null && 
                        email !== undefined && 
                        email !== '' &&
                        String(email).trim() !== '';
        const isValidFormat = hasEmail && this.IsEmail;
        return isValidFormat;
      }
    },
  },
  watch: {
    value() {
      this.temp_value = this.value;
    },
    temp_value: {
      handler() {
        this.checkDataGuid = '';
        this.$emit('input', this.temp_value);
      }, deep: true

    }
  },
  methods: {
    InitCheckEndOpt(){
      if((this.value.phoneIsVerify && this.optType=='mobile') || (this.value.emailIsVerify && this.optType=='email'))
        this.isCheckEndOpt = true;
    },
    InitCaptchaVerifyParam() {
      if (this.captchaVerifyParam && this.isLoginUse) {
        this.finishSlideGeetest(this.captchaVerifyParam)
      }
    },
    //生成GUID
    generateGuid() {
      // 使用 JavaScript 生成 GUID 的函数  
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return `${s4()}${s4()}-${s4()}-${4 | s4()}-${5 | s4()}-${s4()}${s4()}${s4()}`;
    },
    async getCellCountryOptions() {
      this.cellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item => {
        return {
          id: item.Code,
          label: item.Name
        }
      });
    },
    async getValidEmailCode(data) {
      const langId = parseInt(localStorage.getItem('currentLangId')) || 1252;
      const params = {
        channel: 'email',
        sendType: 'verificationCode',
        typename: data?.typename || 'CPS_Login',
        lot_number: data?.lot_number || '',
        captcha_output: data?.captcha_output || '',
        pass_token: data?.pass_token || '',
        gen_time: data?.gen_time || '',
        email: this.temp_value.emailInput,
        langId: langId
      };

      try {
        const res = await userService.sendVerification(params);
        if (!res || !res.isSuccessful) {
          if (res?.statusCode === 1001 || res?.data === '验证码验证失败') {
            this.$swal({
              text: this.$t("lbl_EMPBE_Geetest_Verification"),
              showCancelButton: false,
              confirmButtonText: this.$t("lbl_EMPBE_Confirm")
            });
            return Promise.reject(new Error('滑块验证失败'));
          }
          const errorMsg = res?.msg?.join('; ') || res?.systemErrorMsg?.join('; ') || '发送邮箱验证码失败';
          this.$Alert(0, errorMsg);
          return Promise.reject(new Error(errorMsg));
        }
        if (res.data) {
          this.startCountdown();
          this.checkDataGuid = res.data; // data 是 Guid
          return Promise.resolve({ status: 200, data: res.data });
        }
        this.$Alert(0, "发送邮箱验证码失败：未返回验证码Guid");
        return Promise.reject(new Error('发送邮箱验证码失败：未返回验证码Guid'));
      } catch (error) {
        this.$Alert(0, error.message || '发送邮箱验证码失败');
        return Promise.reject(error);
      }
    },
    async getValidSMSCode(data) {
      const RLang = parseInt(localStorage.getItem('currentLangId')) || 1252;
      // 获取 showid（从配置或默认值）
      const contactUsConfig = getContactUsConfig('supplier');
      const showid = contactUsConfig?.showid || DEFAULT_SHOW_ID || '9991';
      
      // 获取 countryId 和 countryTelCode
      // contactPhoneCountry 是区号字符串，例如 "86" 或 "852"
      // 注意：contactPhoneCountryCode 是选择器的 id（也是区号），contactPhoneCountry 是从 label 中提取的区号
      const countryTelCode = this.temp_value.contactPhoneCountry || this.temp_value.contactPhoneCountryCode || '';
      // 清理区号，只保留数字
      const cleanCountryTelCode = String(countryTelCode).replace(/[^0-9]/g, '');
      
      // 判断是否为国际号码：区号不是 86 或空，则为国际号码
      const isInternational = cleanCountryTelCode !== '' && cleanCountryTelCode !== '86';
      
      // 获取 countryId（86 返回 44，其他返回 null）
      const countryId = cleanCountryTelCode === '86' || cleanCountryTelCode === '' ? 44 : null;
      
      const params = {
        channel: 'mobile',
        sendType: 'verificationCode',
        typename: data?.typename || 'CPS_Login',
        lot_number: data?.lot_number || '',
        captcha_output: data?.captcha_output || '',
        pass_token: data?.pass_token || '',
        gen_time: data?.gen_time || '',
        CellNum: this.temp_value.mobileInput,
        countryId: countryId,
        countryTelCode: cleanCountryTelCode,
        showid: showid.toString(),
        RLang: RLang,
        isInternational: isInternational ? 'true' : 'false'
      };

      try {
        const res = await userService.sendVerification(params);
        if (!res || !res.isSuccessful) {
          if (res?.statusCode === 1001 || res?.data === '验证码验证失败') {
            this.$swal({
              text: this.$t("lbl_EMPBE_Geetest_Verification"),
              showCancelButton: false,
              confirmButtonText: this.$t("lbl_EMPBE_Confirm")
            });
            return Promise.reject(new Error('滑块验证失败'));
          }
          const errorMsg = res?.msg?.join('; ') || res?.systemErrorMsg?.join('; ') || '发送短信验证码失败';
          this.$Alert(0, errorMsg);
          return Promise.reject(new Error(errorMsg));
        }
        if (res.data) {
          this.startCountdown();
          this.checkDataGuid = res.data; // data 是 Guid
          return Promise.resolve({ status: 200, data: res.data });
        }
        this.$Alert(0, "发送短信验证码失败：未返回验证码Guid");
        return Promise.reject(new Error('发送短信验证码失败：未返回验证码Guid'));
      } catch (error) {
        this.$Alert(0, error.message || '发送短信验证码失败');
        return Promise.reject(error);
      }
    },
    // 根据区号获取 countryId
    getCountryIdFromCode(countryTelCode) {
      if (!countryTelCode || countryTelCode === '') {
        return 44; // 默认中国
      }
      
      // 清理区号，只保留数字
      const cleanCode = String(countryTelCode).replace(/[^0-9]/g, '');
      
      // 如果区号是 86，返回中国 countryId (44)
      if (cleanCode === '86') {
        return 44;
      }
      
      // 从 cellCountryOptions 中查找匹配的区号
      // cellCountryOptions 的结构：{ id: item.Code (区号), label: item.Name (名称) }
      const matched = this.cellCountryOptions.find(opt => {
        const optCode = String(opt.id || opt.code || '').replace(/[^0-9]/g, '');
        return optCode === cleanCode;
      });
      
      // 如果找到匹配项，说明是有效的国际区号
      // 由于 cellCountryOptions 中没有 countryId 字段，我们只能通过区号判断
      // 86 是中国，其他都是国际号码
      if (matched) {
        // 如果匹配到的是 86，已经在上面的判断中返回了 44
        // 这里匹配到的是其他区号，返回 null 让后端处理，或者可以根据需要返回一个默认值
        // 但为了安全，如果区号不是 86，我们返回 null，让后端根据 isInternational 参数判断
        return null; // 国际号码，让后端处理
      }
      
      // 如果没有找到匹配项，但区号不是 86，也当作国际号码处理
      // 返回 null，让后端根据 isInternational 参数判断
      return null;
    },
    //滑块完成后的回调事件
    finishSlideGeetest(captchaVerifyParam, resolve) {
      this.isStartOpt=true;
      this.$nextTick(() => {
        if (this.optType == 'email') {
          this.getValidEmailCode(captchaVerifyParam).then(result => {
            // 使用resolve函数将业务结果传递回子组件
            if (resolve) resolve();
          });
        } else {
          this.getValidSMSCode(captchaVerifyParam).then(result => {
            // 使用resolve函数将业务结果传递回子组件
            if (resolve) resolve();
          });
        }
      });
    },
    PhoneSelected(obj) {
      this.temp_value.contactPhoneCountryCode = obj.id;
      this.temp_value.contactPhoneCountry = obj.label.match(/\d+/)[0];

    },
    handleOtpPaste(event) {
      event.preventDefault();
      const pasteData = event.clipboardData.getData('text').replace(/[^0-9]/g, '').replace(/\s/g, '').slice(0, 4);
      pasteData.split('').forEach((char, index) => {
        if (index < 4) {
          this.otpDigits[index] = char;
        }
      });
      const lastFilledIndex = Math.min(pasteData.length - 1, 3);
      const nextInput = this.$el.querySelectorAll('.otp-input')[lastFilledIndex + 1];
      if (nextInput) nextInput.focus();

      this.checkOTP();
    },
    handleOtpKeydown(index, event) {
      if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
        const prevInput = this.$el.querySelectorAll('.otp-input')[index - 1];
        if (prevInput) prevInput.focus();
      }
    },
    handleOtpInput(index, event) {
      const value = event.target.value.replace(/[^0-9]/g, '').replace(/\s/g, '');
      this.otpDigits[index] = value;

      this.clearOtpError();
      if (value && index < 3) {
        const nextInput = this.$el.querySelectorAll('.otp-input')[index + 1];
        if (nextInput) nextInput.focus();
      }
      // Auto-submit when all digits are filled
      if (this.otpDigits.every(d => d) && this.otpDigits.length === 4) {
        this.checkOTP();
      }
    },
    clearOtpError() {
      this.otpError = false;
    },
    //检查OTPCode
    checkOTP() {
      if (!this.checkDataGuid) {
        return;
      }

      var params_checkCode = {
        guid: this.checkDataGuid,
        code: this.otpDigits.join(''),
      };
      CompanyInfoService.checkValidCode(params_checkCode).then((res) => {
        if (res.data != "True") this.otpError = true;
        else {
          if (this.optType == 'email') this.temp_value.emailIsVerify = true;
          else this.temp_value.phoneIsVerify = true;
          this.isCheckEndOpt = true;
          this.$emit('CompleteVerification', { VerifyGuid: this.checkDataGuid, VerifyCode: this.otpDigits.join('') }) //完成验证事件
        }
      });
    },
    sendOTP() {
      if (!this.isFormValid) {
        if (this.optType === 'mobile') {
          const countryCode = this.temp_value.contactPhoneCountryCode;
          if (!countryCode || countryCode === null || countryCode === undefined || String(countryCode).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseSelectCountry') || '请选择国家/地区');
            return;
          }
          const mobile = this.temp_value.mobileInput;
          if (!mobile || mobile === null || mobile === undefined || String(mobile).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseEnterMobile') || '请输入手机号');
            return;
          }
        } else {
          const email = this.temp_value.emailInput;
          if (!email || email === null || email === undefined || String(email).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseEnterEmail') || '请输入邮箱地址');
            return;
          }
          if (!this.IsEmail) {
            this.$Alert(0, this.$t('lbl_EMPBE_InvalidEmailFormat') || '请输入正确的邮箱地址格式');
            return;
          }
        }
        return;
      }
      this.$refs.captchaInstance.showGeetest();
    },
    validateForm() {
      if (!this.isFormValid) {
        if (this.optType === 'mobile') {
          const countryCode = this.temp_value.contactPhoneCountryCode;
          if (!countryCode || countryCode === null || countryCode === undefined || String(countryCode).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseSelectCountry') || '请选择国家/地区');
            return false;
          }
          const mobile = this.temp_value.mobileInput;
          if (!mobile || mobile === null || mobile === undefined || String(mobile).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseEnterMobile') || '请输入手机号');
            return false;
          }
        } else {
          const email = this.temp_value.emailInput;
          if (!email || email === null || email === undefined || String(email).trim() === '') {
            this.$Alert(0, this.$t('lbl_EMPBE_PleaseEnterEmail') || '请输入邮箱地址');
            return false;
          }
          if (!this.IsEmail) {
            this.$Alert(0, this.$t('lbl_EMPBE_InvalidEmailFormat') || '请输入正确的邮箱地址格式');
            return false;
          }
        }
        return false;
      }
      return true;
    },
    startCountdown() {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
  }
};
</script>

<style scoped>
.OptDom {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.otp-error {
  color: red;
}

/* OTP 输入框错误样式 */
.otp-input-error {
  outline: 1px solid red !important;
}

.otp-inputs {
  display: inline-flex;
  /* 原型图要求 display: inline-flex */
  gap: 4px;
  /* 原型图要求 gap: 4px */
  justify-content: flex-start;
  /* 原型图要求 justify-content: flex-start */
  align-items: flex-start;
  /* 原型图要求 align-items: flex-start */
  margin: 0;
  padding: 0;
  border: none;
  /* 确保容器本身没有边框 */
  outline: none;
  /* 确保没有 outline */
}

.otp-input {
  width: 32px;
  /* 固定宽度 */
  min-height: 40px;
  /* 最小高度 */
  padding: 0 10px;
  /* 左右 padding */
  background: white;
  border: none;
  /* 使用 outline 而不是 border */
  border-radius: 4px;
  outline: 1px solid rgba(0, 0, 0, 0.23);
  /* 原型图要求 outline: 1px rgba(0, 0, 0, 0.23) solid */
  outline-offset: -1px;
  /* 原型图要求 outline-offset: -1px */
  text-align: center;
  /* 文字居中 */
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
  transition: outline-color 0.2s;
  display: flex;
  /* 使用 flex 布局 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
}

.otp-input:focus {
  outline: 2px solid #7366FF;
  /* focus 时使用紫色 outline */
  outline-offset: -2px;
  /* 保持 outline 向内 */
}

/* 验证码错误消息样式 */
.otp-error-message {
  color: #D32F2F;
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 15.60px;
  margin-top: 8px;
  word-wrap: break-word;
}

/* ===== Verification code button：椭圆(pill)风格（只影响本组件） ===== */
.UserSetting-VerifyBtn {
  padding: 16px 24px !important;
  border-radius: 999px !important;
  outline-offset: -1px !important;
  font-size: 14px !important;
  font-family: Inter, sans-serif !important;
  font-weight: 600 !important;
  line-height: 14px !important;
  box-shadow: none !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
}

/* outline-primary 默认态：紫色描边+紫字 */
:deep(.btn-outline-primary.UserSetting-VerifyBtn) {
  border-color: #7366FF !important;
  color: #7366FF !important;
  background: transparent !important;
}

/* hover：填充主色；disabled 不触发 */
:deep(.btn-outline-primary.UserSetting-VerifyBtn:hover:not(:disabled):not(.disabled)) {
  background: #4433FF !important;
  border-color: #4433FF !important;
  color: #FFFFFF !important;
}

/* disabled：灰描边+灰字（保持椭圆），hover 不变化 */
:deep(.btn-outline-primary.UserSetting-VerifyBtn:disabled),
:deep(.btn-outline-primary.UserSetting-VerifyBtn.disabled),
.UserSetting-VerifyBtn:disabled {
  opacity: 1 !important;
  cursor: not-allowed !important;
  background: transparent !important;
  border-color: rgba(0, 18, 26, 0.38) !important;
  color: rgba(0, 18, 26, 0.38) !important;
}

/* 已验证时的绿色勾选图标 - 使用绝对定位，不影响原有布局 */
.mobile-input-wrapper,
.email-input-wrapper {
  position: relative;
}

.verified-check-icon-mobile,
.verified-check-icon-email {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  pointer-events: none;
}

/* 禁用输入框时的文本颜色 */
.is-verified-mobile :deep(.CPSForm-input:disabled),
.is-verified-mobile :deep(.form-group input:disabled),
.is-verified-mobile :deep(.form-group input[disabled]),
.is-verified-mobile :deep(.form-control:disabled),
.is-verified-email :deep(.CPSForm-input:disabled),
.is-verified-email :deep(.form-group input:disabled),
.is-verified-email :deep(.form-group input[disabled]),
.is-verified-email :deep(.form-control:disabled) {
  color: rgba(0, 0, 0, 0.38) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.38) !important;
}


</style>